var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',[(_vm.isLoaded)?_c('paginated-table',{attrs:{"title":_vm.tableTitle,"icon":_vm.tableIcon,"columns":_vm.columns,"data":_vm.reviews},on:{"updatePagination":_vm.updatePagination}}):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }